import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedPraticaEdilizia } from '../../../types/red'
import { TIPI_PRATICA_EDILIZIA_LABEL, STATO_PRATICA_CONFIG } from '../../../constants/red'
import { redApi } from '../../../services/api'

const TabPraticheEdilizie: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [pratiche, setPratiche] = useState<RedPraticaEdilizia[]>([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ tipologia: 'cila', numero_protocollo: '', ente_rilascio: '', stato: 'bozza', data_presentazione: '', data_rilascio: '', data_scadenza: '', note: '' })

  const load = () => {
    redApi.praticheEdilizie.listByImmobile(immobile.id).then(res => {
      setPratiche(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleCreate = async () => {
    try {
      await redApi.praticheEdilizie.create({
        immobile_id: immobile.id,
        tipologia: form.tipologia,
        numero_protocollo: form.numero_protocollo || null,
        ente_rilascio: form.ente_rilascio || null,
        stato: form.stato,
        data_presentazione: form.data_presentazione || null,
        data_rilascio: form.data_rilascio || null,
        data_scadenza: form.data_scadenza || null,
        note: form.note || null,
      })
      toast.success('Pratica aggiunta')
      setForm({ tipologia: 'cila', numero_protocollo: '', ente_rilascio: '', stato: 'bozza', data_presentazione: '', data_rilascio: '', data_scadenza: '', note: '' })
      setShowForm(false)
      load()
      onUpdate()
    } catch { toast.error('Errore creazione') }
  }

  if (loading) return <div className="text-gray-400">Caricamento...</div>

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Pratiche Edilizie</h2>
        <button onClick={() => setShowForm(v => !v)} className="btn-primary text-sm">+ Aggiungi</button>
      </div>

      {showForm && (
        <div className="card p-4 mb-4 grid grid-cols-3 gap-3">
          <div><label className="label">Tipologia</label>
            <select className="select" value={form.tipologia} onChange={e => setForm({...form, tipologia: e.target.value})}>
              {Object.entries(TIPI_PRATICA_EDILIZIA_LABEL).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div><label className="label">Protocollo</label><input className="input" value={form.numero_protocollo} onChange={e => setForm({...form, numero_protocollo: e.target.value})} /></div>
          <div><label className="label">Ente</label><input className="input" value={form.ente_rilascio} onChange={e => setForm({...form, ente_rilascio: e.target.value})} /></div>
          <div><label className="label">Stato</label>
            <select className="select" value={form.stato} onChange={e => setForm({...form, stato: e.target.value})}>
              {Object.keys(STATO_PRATICA_CONFIG).map(k => <option key={k} value={k}>{STATO_PRATICA_CONFIG[k].label}</option>)}
            </select>
          </div>
          <div><label className="label">Presentazione</label><input type="date" className="input" value={form.data_presentazione} onChange={e => setForm({...form, data_presentazione: e.target.value})} /></div>
          <div><label className="label">Rilascio</label><input type="date" className="input" value={form.data_rilascio} onChange={e => setForm({...form, data_rilascio: e.target.value})} /></div>
          <div><label className="label">Scadenza</label><input type="date" className="input" value={form.data_scadenza} onChange={e => setForm({...form, data_scadenza: e.target.value})} /></div>
          <div className="col-span-3"><label className="label">Note</label><input className="input" value={form.note} onChange={e => setForm({...form, note: e.target.value})} /></div>
          <div className="col-span-3"><button onClick={handleCreate} className="btn-primary text-sm">Salva</button></div>
        </div>
      )}

      <div className="space-y-2">
        {pratiche.map(p => {
          const cfg = STATO_PRATICA_CONFIG[p.stato]
          return (
            <div key={p.id} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div className="text-sm font-medium text-gray-800">{TIPI_PRATICA_EDILIZIA_LABEL[p.tipologia] || p.tipologia} {p.numero_protocollo && `· ${p.numero_protocollo}`}</div>
                <div className="text-xs text-gray-400">
                  {p.ente_rilascio && `Ente: ${p.ente_rilascio}`}
                  {p.data_presentazione && ` · Presentata: ${new Date(p.data_presentazione).toLocaleDateString('it-IT')}`}
                  {p.data_scadenza && ` · Scade: ${new Date(p.data_scadenza).toLocaleDateString('it-IT')}`}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ color: cfg.color, backgroundColor: '#f3f4f6' }}>{cfg.label}</span>
                <button onClick={async () => { if (!confirm('Eliminare?')) return; await redApi.praticheEdilizie.delete(p.id); toast.success('Eliminata'); load(); onUpdate() }} className="text-xs text-red-500 hover:text-red-700">🗑</button>
              </div>
            </div>
          )
        })}
        {pratiche.length === 0 && <div className="text-center py-10 text-gray-400">Nessuna pratica registrata.</div>}
      </div>
    </div>
  )
}

export default TabPraticheEdilizie
